<template>
  <v-dialog v-if="archive!={}" persistent width="700" v-model="dialog">
    <template v-slot:activator="{ on }">

      <slot name="activator" v-bind:data="{on: on, load : load}">
        <v-btn @click="load()" v-on="on" color="teal darken-4" fab small dark>
          <v-icon class="schema-edit-icon" dark>pageview</v-icon>
        </v-btn>
      </slot>

    </template>

    <v-card style="position: relative">
      <div v-if="archive.thumbImg" :class="page < 2 ? 'arch_nav arch_nav-right' : 'arch_nav arch_nav-left'">
        <div @click="changePage()" class="nav_cont">
          <div :class="page < 2 ? 'arrow_nav arch_nav-right' : 'arrow_nav arch_nav-left'">
          <v-icon style="opacity: 0.8;" x-large> {{ page < 2 ? 'mdi-chevron-right' : 'mdi-chevron-left'}}</v-icon>
            </div>
        </div>
      </div>
      <v-stepper v-if="archive.thumbImg" v-model="page">

        <v-stepper-items id="work-block">

          <v-stepper-content step="1">
            <v-card-text>
              <v-layout height="90vh">
                <v-flex lg12 sm12 xs12>
                  <v-img v-if="archive.thumbImg && archive.type !='application/pdf'"  contain aspect-ratio="1" max-height="90vh " max-width="90vw" class="cursorPointner" :src="'data:image/jpeg;base64,'+ archive.data"></v-img>
                  <PDFViewer v-if="archive.thumbImg && archive.type =='application/pdf'"  :base64="`data:${this.archive.type};base64,${this.archive.data}`"></PDFViewer>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card-title class="subheading font-weight-bold">{{ archive.customName }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout>
                <v-layout  row  wrap>
                  <v-flex pa-1 d-flex lg5 sm12 xs12>
                    <v-text-field  :value="archive.archType" label="Typ archiwum:" readonly></v-text-field>
                  </v-flex>
                  <v-flex pa-1 d-flex lg5 sm12 xs12>
                    <v-text-field  :value="archive.note" label="Notatka:" readonly></v-text-field>
                  </v-flex>
                  <v-flex lg12 sm12 xs12>
                    <v-textarea  :value="archive.text" label="Text:" readonly></v-textarea>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-card-text>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-progress-linear indeterminate color="primary" v-if="loading" spacing="pr-4"></v-progress-linear>
        <v-btn style="z-index: 99999999" color="blue darken-1" flat @click="dialog=false">{{ $t('cyclic.abort') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PDFViewer from '@/components/pdf/Viewer'
import Messenger from "@/plugins/Messenger";

export default {
  name: "Archive",
  props : ['schemaId', 'formId'],
  components:{
    PDFViewer
  },

  data(){
    return{
      loading:true,
      dialog : false,
      archive : {},
      archivesForm :[],
      file : null,
      page : 1,
    }
  },
  methods:{
    changePage(){
      this.page < 2 ? this.page++ : this.page--;
    },
    load(){
      this.dialog = true;
      this.loading = true
      this.archive = {}
      let archiveForm = this.archivesForm.find(af => af.idForm == this.formId)
      if(this.archivesForm && archiveForm){
         this.archive = archiveForm.archive
        this.loading = false
        return
      }

      this.$http.get(`document/schema/${this.schemaId}/form/${this.formId}/archive`)
        .then(data =>{
          this.archive = data.data
          this.archivesForm.push({'idForm' : this.formId, "archive" : data.data})
          this.loading = false
        })
      .catch(()=> {
        this.dialog = false
        Messenger.emitError("Bład przy pobieraniu archiwum")
      })
    }
  }


}
</script>

<style scoped>
.arch_nav{
  position: absolute;
  height: 100%;
  width: 10%;
  z-index: 99999998;
}
.arch_nav-right{
  right: 0;
}
.arch_nav-left{
  left: 0;
}
.arrow_nav{
  position:absolute;
  top:50%;
}
.nav_cont{
  height: 80%;
  width: 100%;
  cursor: pointer;
  visibility: hidden;
}
.arch_nav:hover{
  background-color: rgba(239, 239, 245,0.7);
}
.arch_nav:hover > div{
  visibility: visible;
}
</style>